export default __webpack_public_path__ + "static/media/project-5.a8ec8b75.jpg";